import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useTipoVinculo = () => {
  const [tipoVinculo, setTipoVinculo] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchTipoVinculo = async () => {
      try {
        const response = await httpClient.get(`/api/users/tipovinculo`);

        const options = response.data.map(
          (tipoVinculo: { value: number; label: string }) => ({
            value: tipoVinculo.value.toString(),
            label: tipoVinculo.label,
          }),
        );
        setTipoVinculo(options);
      } catch (error) {
        console.error('Erro ao buscar Tipo Vinculo', error);
      }
    };

    fetchTipoVinculo();
  }, []);

  return tipoVinculo;
};
